import React from 'react';

export { IDEAS_AND_COMPANIES } from './routes';
export * from './routes';
export * from './reporting';

export const SivaPageWrapper = React.lazy(() => import('./page'));
